
<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="700px" transition="dialog-transition" @click:outside="closeDialog">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Boleto</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <BillProfile :id="bill.id"></BillProfile>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text @click="closeDialog" class="red" dark small>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {CurrencyDirective} from 'vue-currency-input'
import { mask } from'vue-the-mask'

export default {
  name: 'ClientDialogShowBill',
  props: {
    bill: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  components:{
    BillProfile: () => import('@/_backoffice/_financial/components/bill/shared/BillProfile.vue')
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      status_map: {
        pending: { text: 'Pendente', color: 'orange', icon: '', },
        canceled: { text: 'Cancelado', color: 'red', icon: '', },
        expired: { text: 'Expirado', color: 'red', icon: '', },
        partially_paid: { text: 'Pago parcialmente', color: 'green', icon: '', },
        paid: { text: 'Pago', color: 'green', icon: '', },
        externally_paid: { text: 'Pago Externamente', color: 'green', icon: '', },
      },
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
  },
}
</script>

<style scoped>

</style>